/**
 * Normaliza um texto para comparação: sem acentos e em minúsculas.
 * Usado nos filtros que fazem a busca no cliente, para "sao" encontrar "São".
 * @param {*} texto valor a ser normalizado
 * @returns {string} texto comparável
 */
export default function normalizaTexto(texto) {
  return String(texto ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
